export enum TipoDeSecaoAcoesDocumento {
  PADRAO = 'padrao',
  BAIXAR = 'baixar',
  ASSINAR = 'assinar',
  CRIAR_PROCESSO_NO_PAPEL_ZERO = 'criarProcessoNoPapelZero',
  ENVIAR_AO_PAPEL_ZERO = 'enviarAoPapelZero',
  COLABORADORES_DO_PROCESSO = 'colaboradoresDoProcesso',
  ALTERAR_RESPONSAVEL_DO_PROCESSO = 'alterarResponsavelDoProcesso',
  PUBLICO = 'publico',
}
